import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import ComponentController from '../../../common/components/component-controller';
const templateUrl = require('./reports.html');

class ReportsController extends ComponentController {
  reports: any[];
  filteredReports: any[];
  currentSite: any;
  startDate: any;
  endDate: any;
  searchTerm: string = '';

  constructor(
    private $state: any,
    private ReportService: any,
    private AuthService: any,
    private $window: any,
    private $stateParams: any
  ) {
    super();
  }

  $onInit = () => {
    let startString = this.$stateParams.startDate.replace(' ', '+');
    let endString = this.$stateParams.endDate.replace(' ', '+');
    this.startDate = moment(startString, 'YYYY-MM-DDTHH:mm:ssZ').toDate();
    this.endDate = moment(endString, 'YYYY-MM-DDTHH:mm:ssZ').toDate();
    this.filteredReports = _.clone(this.reports);
  };

  updateRange = (startDate, endDate) => {
    let params = {
      startDate: moment(startDate).format(),
      endDate: moment(endDate).format()
    };
    this.$state.go('app.epx.reports', params);
  };

  filterReports = () => {
    if (this.searchTerm.length) {
      this.filteredReports = _.filter(this.reports, r =>
        r.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.filteredReports = _.clone(this.reports);
    }
  };

  downloadReport = (report, $event) => {
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    this.$window.location = report.downloadLink;
  };
}

angular.module('ciApp').component('epx.reports', {
  templateUrl: templateUrl,
  bindings: {
    reports: '<',
    currentSite: '<'
  },
  controller: [
    '$state',
    'ReportService',
    'AuthService',
    '$window',
    '$stateParams',
    ReportsController
  ]
});



// WEBPACK FOOTER //
// ./app/epx/reports/reports.component.ts